/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React from 'react';
import './BrushStroke.scss';

const BrushStroke = ({ children, className = '' }) => {
  return (
    <span className={`brush-stroke-container ${className}`}>
      {children}
      <svg
        className="brush-stroke-svg"
        viewBox="0 0 300 20"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 15 Q 50 5, 150 10 T 295 12"
          stroke="currentColor"
          strokeWidth="8"
          strokeLinecap="round"
          fill="none"
          className="brush-path"
        />
      </svg>
    </span>
  );
};

export default BrushStroke;
